import { useEffect, useState } from "react";
import LoadingComponent from "../../../default_components/LoadingComponent";
import { useTranslation } from "react-i18next";
import CreditCardForm from "./CreditCardForm";
import HostedFieldsUpdate from "./HostedFieldsUpdate";
import clockImage from "../../../default_images/clock.svg";
import $ from "jquery";
import lsKeys from "../../../default_values/defaultKeys";
import { useProfileStore } from "../../../../stores/profileStore";
import { shallow } from "zustand/shallow";
import TeambookDialog from "../../../default_components/TeambookDialog";

const ChangePaymentModal = ({
  changePaymentRequest,
  loading,
  closeModal,
  creditCard,
}) => {
  const isDarkTheme = localStorage.getItem(lsKeys.THEME) === "dark";

  const { t } = useTranslation();

  const [token, setToken] = useState();
  const [errorText, setErrorText] = useState();
  const [loadingText, setLoadingText] = useState();
  const [userData, setUserData] = useState({});
  const [profile] = useProfileStore((state) => [state.profile], shallow);

  useEffect(() => {
    HostedFieldsUpdate(setToken, changePaymentRequest, setErrorText, setLoadingText, isDarkTheme, userData, profile);
  }, []);

  useEffect(() => {
    setLoadingText(null);

    setTimeout(() => {
      setErrorText(null);
      $(".pay-button").prop("disabled", false);
    }, 4000);
  }, [errorText]);

  return (
    !loading &&
    (token ? (
      <TeambookDialog
        title={t("settings.subscription.customer_text")}
        open={true}
        onClose={closeModal}
        withCloseButton
        size={"small"}
        content={
          <>
            {creditCard.last_4 && <p>Your current credit card number is **** **** **** {creditCard.last_4}.</p>}

            <p>
              Expiring at {creditCard.expiration_month}/{creditCard.expiration_year}
            </p>

            <CreditCardForm />

            {loadingText && (
              <p className="blink-text">
                {loadingText} <img src={clockImage} />
              </p>
            )}

            {errorText && <p className="error-text" style={{maxWidth: "400px"}}>{errorText}</p>}
          </>
        }
      />
    ) : (
      <LoadingComponent />
    ))
  );
};

export default ChangePaymentModal;
